import {
  PAYMENT_DETAIL_FAILED,
  PAYMENT_DETAIL_FETCHING,
  PAYMENT_DETAIL_SUCCESS,
  server
} from '../../constants'
import backendEndpoint from '../../api/etrBackend'
import { DocumentDetailModel } from '../../models/documentDetail'
import * as documentAction from './document.detail.action'

export const setPaymentDetailFetchingToState = () => ({
  type: PAYMENT_DETAIL_FETCHING
})

export const setPaymentDetailSuccessToState = (payload: any) => ({
  type: PAYMENT_DETAIL_SUCCESS,
  payload
})

export const setPaymentDetailFailedToState = () => ({
  type: PAYMENT_DETAIL_FAILED
})

export const getPaymentDetail = (id: string) => {
  return async (dispatch: any) => {
    try {
      dispatch(setPaymentDetailFetchingToState())
      const result = await backendEndpoint.get(`http://localhost:3001/documents/${id}`) //await backendEndpoint.get(`${server.PAYMENT_DETAIL_URL}/${id}`)

      dispatch(setPaymentDetailSuccessToState(result.data.documentDetails[0]))
    } catch (error) {
      dispatch(setPaymentDetailFailedToState())
    }
  }
}

export const updatePaymentDetail = (docId: number, paymentData: DocumentDetailModel) => {
  return async (dispatch: any) => {
    try {
      dispatch(setPaymentDetailFetchingToState())
      const payload = paymentData as Partial<DocumentDetailModel>
      delete payload.creditCard_Number_data
      delete payload.creditCard_Number
      await backendEndpoint.patch(`${server.PAYMENT_DETAIL_URL}/${docId}`, payload)
      dispatch(setPaymentDetailSuccessToState(paymentData))

      paymentData.documentID &&
        dispatch(documentAction.handleGetDocumentById(paymentData.documentID?.toString()))
    } catch (error) {
      dispatch(setPaymentDetailFailedToState())
    }
  }
}
